module.exports = __webpack_public_path__ + "static/ActaDeck-BookItalic-d3d7990b42eb417fce5fbcec5c81310e.woff";